import { NavItem } from './nav-item';

export class SignOutNavItem extends NavItem {}
